import ReactDOM from 'react-dom';
import React, { StrictMode } from 'react';
import ErrorBoundary from '../../utils/react/ErrorBoundary';
import { ApolloProvider } from '@apollo/client';
import WishlistContainer from '../customers/components/WishlistContainer';
import defaultClient from '../_shared/apolloClient';

import '../product-listing-page/style.scss';
import ProminentMessage from '../page/components/ProminentMessage';
import { heapTrack } from '../../utils/helpers';

const onError = (err: Error) => {
  heapTrack('wishlist crash', { url: window.location.pathname, err: (err && err.message) || undefined });
};

const targetElement = document.getElementById('REACT-WISHLIST');
const renderWishlist = () => {
  return ReactDOM.render(
    <StrictMode>
      <ErrorBoundary
        onError={onError}
        errorRender={() => (
          <ProminentMessage
            subtitle="Something went wrong"
            callToAction={{ text: 'Reload Page', behavior: 'reload-page' }}
          />
        )}
      >
        <ApolloProvider client={defaultClient}>
          <WishlistContainer />
        </ApolloProvider>
      </ErrorBoundary>
    </StrictMode>,
    targetElement
  );
};

export { renderWishlist };
